import { atom, selector } from 'recoil'
import { DEFAULT_MARKET_SYMBOL } from '@/constants/config'

export const marketMapState = atom({
  key: 'MarketMap',
  default: {}
})

export const marketListState = atom({
  key: 'MarketList',
  default: []
})

export const marketTickerMapState = atom({
  key: 'MarketTickerMap',
  default: {}
})

export const futuresMarketInfoMapState = atom({
  key: 'FuturesMarketInfoMap',
  default: {}
})

export const indexPriceMapState = atom({
  key: 'IndexPriceMap',
  default: {}
})

export const markPriceMapState = atom({
  key: 'MarkPriceMap',
  default: {}
})

export const marketSymbolState = atom({
  key: 'MarketSymbol',
  default: DEFAULT_MARKET_SYMBOL
})

export const marketIsReadyValue = selector({
  key: 'MarketIsReady',
  get: ({ get }) => get(marketListState).length > 0,
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const marketInfoValue = selector({
  key: 'MarketInfo',
  get: ({ get }) => {
    const symbol = get(marketSymbolState)
    return get(marketMapState)[symbol] || {}
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const marketTickerValue = selector({
  key: 'MarketTicker',
  get: ({ get }) => {
    const symbol = get(marketSymbolState)
    return get(marketTickerMapState)[symbol] || {}
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const futuresMarketOpenInterestMapState = atom({
  key: 'FuturesMarketOpenInterestMap',
  default: {}
})
